import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	isChangeOnlyOption: ForNodeType<boolean>;
	onSetIsChangeOnlyOption: (value: boolean) => void;
};

export const QuestionPlanIsChangeOnlyOption = ({ onSetIsChangeOnlyOption, isChangeOnlyOption }: Props) => {
	const label = "オプションのみ予約変更可能";
	const guide = "予約変更時にオプションのみ変更可能なプランに設定できます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isChangeOnlyOption.isEdited}
			hasError={Boolean(isChangeOnlyOption.error)}
			inputChildren={
				<CheckboxField
					value={isChangeOnlyOption.value}
					label={"オプションのみ予約変更可能にする"}
					handleChange={onSetIsChangeOnlyOption}
					errorMessage={isChangeOnlyOption.error}
				/>
			}
		/>
	);
};

QuestionPlanIsChangeOnlyOption.displayName = "QuestionPlanIsChangeOnlyOption";
